export const inspectReport = {
  clickTab: 'n.4154.8425.0' // 点击检测资质tab
}
